import { useEffect } from 'react';
import { useInfiniteHits } from 'react-instantsearch';
import { useSearchNBHitsContext } from '../components/SearchContext/SearchContext';
const SearchNBHitsStats = () => {
    const { results } = useInfiniteHits();
    const { nbHits, index, query } = results || {};
    const { nbHits: contextNBHits, setnbHits } = useSearchNBHitsContext();
    useEffect(() => {
        if (typeof index !== 'undefined' && typeof nbHits !== 'undefined') {
            const nbHitExistsIndex = contextNBHits.findIndex((item) => item.index === index);
            const value = query && query.length > 0 ? nbHits : 0;
            const newEntry = { index, nbHits: value, query: query || '' };
            if (nbHitExistsIndex !== -1) {
                setnbHits((prev) => prev.map((item) => (item.index === index ? newEntry : item)));
            }
            else {
                setnbHits([...contextNBHits, newEntry]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index, nbHits, results === null || results === void 0 ? void 0 : results.query]);
    return null;
};
export default SearchNBHitsStats;
